module.exports = __webpack_public_path__ + "static/media/Jessie_Lemon.8ad7e231.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/LandingPage/Components/PlateSection/Header/img/Jessie_Lemon.JPG
// module id = 56
// module chunks = 0